import { requestAuthAdmin } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';
export const SPAWN_POINTS_PATH = '/api-admin/v0/map/spawn-points';
export async function requestSpawnPoints(method, { id, point, revision, requestId } = {}, token, environment, signal) {
  if (getSelectedEnvironment() !== environment) throw new Error('Spawn environment changed. Reload the selected environment.');
  const writing = method !== 'GET';
  if (writing && (!Number.isSafeInteger(revision) || revision < 0 || !requestId)) throw new Error('A revision and request ID are required.');
  const response = await requestAuthAdmin(`${SPAWN_POINTS_PATH}${id ? `/${encodeURIComponent(id)}` : ''}`, {
    method,
    ...(signal ? { signal } : {}),
    ...(writing ? { body: JSON.stringify({ expected_revision: revision, request_id: requestId, ...(point ? { point } : {}) }) } : {}),
  }, token);
  let body;
  try { body = await response.json(); } catch { throw Object.assign(new Error(`Spawn response unavailable (${response.status})`), { ...(writing && response.ok ? { uncertain: true } : { status: response.status }) }); }
  if (!response.ok) throw Object.assign(new Error(body?.msg || body?.message || `Spawn request failed (${response.status})`), { status: response.status, code: body?.code });
  const data = body?.data;
  if (!Number.isSafeInteger(data?.revision) || !Array.isArray(data?.points)) throw Object.assign(new Error('Invalid spawn collection response'), writing ? { uncertain: true } : {});
  return data;
}
export const getSpawnPoints = (token, environment, signal) => requestSpawnPoints('GET', {}, token, environment, signal);
